import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { FielderHard } from '@core/theme/baseTheme';

export const DashboardPaper = styled(Paper)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

export const DashboardSectionTitle = styled(Typography)(() => ({
  color: FielderHard,
  fontSize: '17px',
  letterSpacing: '0.7px',
  fontWeight: 500,
}));

export const DashboardTableWrapper = styled(Box)(() => ({
  width: '100%',
  overflow: 'auto',
}));
